module.exports = __webpack_public_path__ + "static/media/md-mic-off.befd3615.svg";